import React from 'react';

const StatusBar = ({ dark }) => {
  const color = dark ? '#fff' : '#1a1a1a';
  const now = new Date();
  const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px 4px', height: 28, flexShrink: 0 }}>
      <span style={{ fontSize: 12, fontWeight: 600, color }}>{time}</span>
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        {/* Signal bars */}
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
          <rect x="0" y="6" width="2" height="4" rx="0.5" fill={color} />
          <rect x="3" y="4" width="2" height="6" rx="0.5" fill={color} opacity="0.7" />
          <rect x="6" y="2" width="2" height="8" rx="0.5" fill={color} opacity="0.5" />
          <rect x="9" y="0" width="2" height="10" rx="0.5" fill={color} opacity="0.3" />
          <rect x="12" y="0" width="2" height="10" rx="0.5" fill={color} opacity="0.2" />
        </svg>
        {/* Wifi */}
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
          <path d="M6 7a1 1 0 110 2 1 1 0 010-2z" fill={color} />
          <path d="M2.5 5C3.6 3.9 4.7 3.5 6 3.5s2.4.4 3.5 1.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" opacity="0.7" />
          <path d="M0.5 2.5C2.1 1 3.9.5 6 .5s3.9.5 5.5 2" stroke={color} strokeWidth="1.2" strokeLinecap="round" opacity="0.35" />
        </svg>
        {/* Battery */}
        <svg width="18" height="9" viewBox="0 0 18 9" fill="none">
          <rect x="0.5" y="0.5" width="15" height="8" rx="2" stroke={color} strokeOpacity="0.4" />
          <rect x="2" y="2" width="11" height="5" rx="1" fill={color} />
          <path d="M16.5 3v3a1.5 1.5 0 000-3z" fill={color} fillOpacity="0.4" />
        </svg>
      </div>
    </div>
  );
};

// Center punch-hole camera
const PunchHole = () => (
  <div style={{ position: 'absolute', top: 10, left: '50%', transform: 'translateX(-50%)', width: 10, height: 10, borderRadius: '50%', background: '#000', zIndex: 10 }} />
);

// Android nav bar (back, home, recent)
const NavBar = ({ dark }) => {
  const color = dark ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.4)';
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 32, height: 36, flexShrink: 0 }}>
      {/* Back chevron */}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 3l-5 5 5 5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {/* Home circle */}
      <div style={{ width: 16, height: 16, borderRadius: '50%', border: `1.8px solid ${color}` }} />
      {/* Recent squares */}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="2" y="4" width="8" height="9" rx="1.5" stroke={color} strokeWidth="1.6" />
        <rect x="5" y="2" width="8" height="9" rx="1.5" stroke={color} strokeWidth="1.6" />
      </svg>
    </div>
  );
};

const AndroidDevice = ({ width = 412, height = 915, dark = false, children, style }) => {
  const bezel = dark ? '#1c1c1c' : '#e0e0e0';
  const border = dark ? '#333' : '#bbb';
  const screenBg = dark ? '#121212' : '#F5F5F5';

  return (
    <div style={{
      width, height, borderRadius: 36, background: bezel,
      border: `2.5px solid ${border}`,
      boxShadow: dark
        ? '0 24px 64px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(255,255,255,0.04)'
        : '0 24px 64px rgba(0,0,0,0.18), inset 0 0 0 1px rgba(255,255,255,0.7)',
      overflow: 'hidden', position: 'relative', display: 'flex', flexDirection: 'column', flexShrink: 0, ...style,
    }}>
      <PunchHole />
      <div style={{ flex: 1, background: screenBg, display: 'flex', flexDirection: 'column', overflow: 'hidden', fontFamily: 'Roboto, sans-serif' }}>
        <StatusBar dark={dark} />
        <div style={{ flex: 1, overflow: 'hidden' }}>{children}</div>
        <NavBar dark={dark} />
      </div>
    </div>
  );
};

export default AndroidDevice;
